import React from 'react';

import AttachmentIcon from 'ui/Icons/AttachmentVertical';

import { isFileImage } from 'ui/files';

import { humanFileSize } from 'utils/formatters/file';

import { FileLayout, FileName, FileSize, FileFooter, FileNameLayout, StyledDownloadIcon } from './styles';
import { FileProps } from './types';
import Item from '../Item';
import FileWithPreview from '../FileWithPreview';

const File: React.FunctionComponent<FileProps> = ({ activity, onDeleteFile, downloadFile, sessionUser }) => {
  if (activity.thumbnail && isFileImage(activity.filename)) {
    return (
      <FileWithPreview
        activity={activity}
        downloadFile={downloadFile}
        onDeleteFile={onDeleteFile}
        sessionUser={sessionUser}
      />
    );
  }

  return (
    <Item activity={activity} onDeleteItem={onDeleteFile} sessionUser={sessionUser}>
      <FileLayout>
        <FileFooter>
          <AttachmentIcon />
          <FileNameLayout>
            <FileName>{activity.filename}</FileName>
            <FileSize>{humanFileSize(activity.size)}</FileSize>
          </FileNameLayout>
          {downloadFile && <StyledDownloadIcon onClick={() => downloadFile(activity.file)()} />}
        </FileFooter>
      </FileLayout>
    </Item>
  );
};

export default File;
